/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration";
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import { useAuthStore } from "@/stores/auth";
import { useClient } from "@/composables/useClient";
import { useNotificationStore } from "@/stores/notification";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  propertyMeta,
  MetaTypesBase,
} from "../common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from "../base";
// @ts-ignore
import type { CreatePersonCheckInDTO } from "../model";
import {
  CreatePersonCheckInDTOTrackedI,
  CreatePersonCheckInDTOMeta,
} from "../model";
// @ts-ignore
import type { PersonCheckInDTO } from "../model";
import { PersonCheckInDTOTrackedI, PersonCheckInDTOMeta } from "../model";
import { applyTransform } from "@/api/mappers/dtoDateMapper";
import { PaginatedResults } from "@/api/models/PaginatedResults";
/**
 * CheckInApi - axios parameter creator
 * @export
 */
export const CheckInApiAxiosParamCreator = function (
  configuration?: Configuration,
) {
  return {
    /**
     * Returns person check in information
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCheckInGet: (
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      const localVarPath = `/staff/check-in`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      if (createdOnStart !== undefined) {
        localVarQueryParameter["createdOnStart"] =
          (createdOnStart as any) instanceof Date
            ? (createdOnStart as any).toISOString()
            : createdOnStart;
      }

      if (createdOnEnd !== undefined) {
        localVarQueryParameter["createdOnEnd"] =
          (createdOnEnd as any) instanceof Date
            ? (createdOnEnd as any).toISOString()
            : createdOnEnd;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Creates a person check in record
     * @param {CreatePersonCheckInDTO} createPersonCheckInDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCheckInPost: (
      createPersonCheckInDTO: CreatePersonCheckInDTO,
      options: RawAxiosRequestConfig = {},
    ): RequestArgs => {
      // verify required parameter 'createPersonCheckInDTO' is not null or undefined
      assertParamExists(
        "staffCheckInPost",
        "createPersonCheckInDTO",
        createPersonCheckInDTO,
      );
      const localVarPath = `/staff/check-in`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createPersonCheckInDTO,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

export type staffCheckInGetParams = {
  createdOnStart?: Date | string;
  createdOnEnd?: Date | string;
};
export type staffCheckInPostParams = {
  createPersonCheckInDTO: CreatePersonCheckInDTO;
};

export const staffCheckInGetMeta = {
  createdOnStart: propertyMeta(
    "createdOnStart",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  createdOnEnd: propertyMeta(
    "createdOnEnd",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
};
export const staffCheckInPostMeta = {
  createPersonCheckInDTO: propertyMeta(
    "createPersonCheckInDTO",
    false,
    true,
    false,
    CreatePersonCheckInDTOMeta,
  ),
};

/**
 * CheckInApi - functional programming interface
 * @export
 */
export const useCheckInApi = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CheckInApiAxiosParamCreator(configuration);
  const client = useClient();
  const authStore = useAuthStore();
  const notificationStore = useNotificationStore();
  return {
    /**
     * Returns person check in information
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCheckInGetRaw(
      props: staffCheckInGetParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PersonCheckInDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffCheckInGet(
        props.createdOnStart,
        props.createdOnEnd,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CheckInApi.staffCheckInGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<PersonCheckInDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<PersonCheckInDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Creates a person check in record
     * @param {CreatePersonCheckInDTO} createPersonCheckInDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCheckInPostRaw(
      props: staffCheckInPostParams,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonCheckInDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffCheckInPost(
        props.createPersonCheckInDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CheckInApi.staffCheckInPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonCheckInDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonCheckInDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },

    /**
     * Returns person check in information
     * @param {Date | string} [createdOnStart]
     * @param {Date | string} [createdOnEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCheckInGet(
      createdOnStart?: Date | string,
      createdOnEnd?: Date | string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PersonCheckInDTO>> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffCheckInGet(
        createdOnStart,
        createdOnEnd,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CheckInApi.staffCheckInGet"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<Array<PersonCheckInDTO>>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("Array<PersonCheckInDTO>", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
    /**
     * Creates a person check in record
     * @param {CreatePersonCheckInDTO} createPersonCheckInDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    staffCheckInPost(
      createPersonCheckInDTO: CreatePersonCheckInDTO,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonCheckInDTO> {
      authStore.requireAuth([
        // authentication staff required
        "staff",
      ]);
      const localVarAxiosArgs = localVarAxiosParamCreator.staffCheckInPost(
        createPersonCheckInDTO,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["CheckInApi.staffCheckInPost"]?.[
          localVarOperationServerIndex
        ]?.url;
      return createRequestFunction<PersonCheckInDTO>(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration,
      )(client)
        .then((res) => {
          applyTransform("PersonCheckInDTO", res.data);
          return res;
        })
        .catch((a) => {
          notificationStore.evalErrorMessage(
            a,
            "An internal error has occured, please try again and contact us if the issue is not resolved!",
          );
          return a;
        });
    },
  };
};

/**
 * CheckInApi - interface
 * @export
 * @interface CheckInApi
 */
export interface CheckInApiInterface {
  /**
   * Returns person check in information
   * @param {string} [createdOnStart]
   * @param {string} [createdOnEnd]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckInApiInterface
   */
  staffCheckInGet(
    createdOnStart?: Date | string,
    createdOnEnd?: Date | string,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<Array<PersonCheckInDTO>>;

  /**
   * Creates a person check in record
   * @param {CreatePersonCheckInDTO} createPersonCheckInDTO
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CheckInApiInterface
   */
  staffCheckInPost(
    createPersonCheckInDTO: CreatePersonCheckInDTO,
    options?: RawAxiosRequestConfig,
  ): AxiosPromise<PersonCheckInDTO>;
}
